import { ThemesEnum, ToranjaThemesEnum } from '../common/enums/themes'

export const updateToranjaTheme = (application: string, isDarkMode: boolean) => {
  let theme: ToranjaThemesEnum

  if (application === ThemesEnum.PJ) {
    theme = isDarkMode ? ToranjaThemesEnum.PJ_DARK : ToranjaThemesEnum.PJ_LIGHT
  } else {
    theme = isDarkMode ? ToranjaThemesEnum.PF_DARK : ToranjaThemesEnum.PF_LIGHT
  }

  document.documentElement.setAttribute('toranja-theme', theme)
}
